// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1QVtY","ranges":"BmiRanges_ranges__fMZcy"};